import { render, staticRenderFns } from "./basic-video-zhijia.vue?vue&type=template&id=42e06dd7&scoped=true&"
import script from "./basic-video-zhijia.vue?vue&type=script&lang=js&"
export * from "./basic-video-zhijia.vue?vue&type=script&lang=js&"
import style0 from "./basic-video-zhijia.vue?vue&type=style&index=0&id=42e06dd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e06dd7",
  null
  
)

export default component.exports